// src/components/Hero.js
import React, { useState, useEffect } from 'react';
import './Hero.css';
import logo_image from '../Assets/logo-image-main.png';

function importAll(r) {
  return r.keys().map(r);
}
const imageSources = importAll(
  require.context('../Assets/HeroImages', false, /\.(jpe?g|png)$/)
);

const slides = imageSources.map(src => ({
  src,
  isPortrait: /-port(?:\.[0-9a-f]{4,})?\.(jpe?g|png)$/i.test(src),
}));

const SLIDE_INTERVAL = 4000; // total time per slide
const PAN_OPTIONS = ['zoom-pan-left', 'zoom-pan-right'];

const Hero = ({
  title    = 'Man of Valor',
  subtitle = 'Running for mens mental health awareness',
}) => {
  const [current, setCurrent] = useState(0);
  // pick each slide’s pan direction once at mount
  const [directions] = useState(() =>
    slides.map(() => PAN_OPTIONS[Math.random() < 0.5 ? 0 : 1])
  );

  // cycle slides
  useEffect(() => {
    const t = setInterval(() => {
      setCurrent(i => (i + 1) % slides.length);
    }, SLIDE_INTERVAL);
    return () => clearInterval(t);
  }, []);

  return (
    <section id="home" className="hero">
      {slides.map(({ src, isPortrait }, idx) => (
        <div
          key={idx}
          className={[
            'hero__slide',
            isPortrait && 'hero__slide--portrait',
            `hero__slide--anim-${directions[idx]}`,
            idx === current && 'active',
          ]
            .filter(Boolean)
            .join(' ')}
        >
          <div
            className="hero__slide-bg"
            style={{ backgroundImage: `url(${src})` }}
          />
          <img src={src} alt="" className="hero__slide-img" />
        </div>
      ))}

      <img src={logo_image} alt="Site Logo" className="hero__logo" />

      <div className="hero__fade hero__fade--top" />
      <div className="hero__fade hero__fade--bottom" />

      <div className="hero__content">
        <h1 className="hero__title">{title}</h1>
        <p className="hero__subtitle">{subtitle}</p>
      </div>

      <div className="hero__dots">
        {slides.map((_, i) => (
          <span
            key={i}
            className={`hero__dot${i===current?' hero__dot--active':''}`}
            onClick={()=>setCurrent(i)}
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;
